<agenx-header></agenx-header>
<main class="agenx-create-edit">
  @if (!loading) {
  <agenx-card-create
      [titleForCardInside]=" 'INFORMACIÓN ' + (data_form.niud != '---' ? 'SUSCRIPTOR' : 'CLIENTE') "
      [title]="'CREAR AFORO ESPECIAL'">
    <div class="agenx-create-edit__inputs--three">
      @if (data_form.niud != '---') {

      }
      <div class="info-style">
        <h5>{{data_form.niud != '---' ? 'Niud' : 'Código'}}:
        </h5>
        <p>{{ data_form.niud != '---' ? data_form.niud : data_form.code }}</p>
      </div>
      <div class="info-style">
        <h5>Nombre:
        </h5>
        <p>{{ data_form.name }}</p>
      </div>
      <div class="info-style">
        <h5>Identificación:
        </h5>
        <p>{{ data_form.identification }}</p>
      </div>
      <div class="info-style">
        <h5>Dirección:
        </h5>
        <p>{{ data_form.address }}</p>
      </div>
      <div class="info-style">
        <h5>Barrio:
        </h5>
        <p>{{ data_form.neighborhood ?? '---' }}</p>
      </div>
      <div class="info-style">
        <h5>Teléfono:
        </h5>
        <p>{{ data_form.phone }}</p>
      </div>
      <div class="info-style last-item">
        <h5>Correo electrónico:
        </h5>
        <p>{{ data_form.email?.replaceAll(';', '; ') ?? '---' }}</p>
      </div>
    </div>
    @if (!data_form.email) {
    <agenx-alert [alertType]="'error'"
      [alertText]="'Este usuario no cuenta con correo electrónico definido.'"></agenx-alert>
    }
  </agenx-card-create>

  <agenx-card [title]="'CREAR AFORO ESPECIAL'" [borderBottomLess]="true">
    <div style="margin-bottom: 0.5rem;">
      <agenx-alert-radio [alertType]="'warning'" [alertText]="'¿Desea crear un aforo sin residuos? '">
        <div class="agenx-create-edit__radios">
          <agenx-radio [control]="getControlOf('radioNoWaste')" [idInput]="'no-waste-1'" [value]="'1'" [checked]="true"
            [nameInput]="'no-waste'" [label]="'Con residuos.'" [type]="'warning'" (valueSend)="onClickNoWaste($event)"
            class="agenx-alert-radio__radio"></agenx-radio>
          <agenx-radio [control]="getControlOf('radioNoWaste')" [idInput]="'no-waste-2'" [value]="'2'" [checked]="false"
            [nameInput]="'no-waste'" [label]="'Sin residuos.'" [type]="'warning'" (valueSend)="onClickNoWaste($event)"
            class="agenx-alert-radio__radio"></agenx-radio>
        </div>
      </agenx-alert-radio>
    </div>
    <div class="agenx-create-edit__inputs--three">
    @if (showForm && !noWaste) {
      <agenx-select [idInput]="'category'" [control]="getControlOf('category')" [options]="categories"
        [label]="'Categoría'" (onChange)="onSelectCategory()"></agenx-select>
      <agenx-select [idInput]="'residue'" [control]="getControlOf('residue')" [options]="residuesCat"
        [label]="'Residuo'" (onChange)="showTable()"></agenx-select>
      <agenx-input [control]="getControlOf('amount')" [type]="'text'" [placeholder]="''" [idInput]="'amount'"
        [label]="'Cantidad'" (onChange)="showTable()"></agenx-input>
      <agenx-table [tableContent]="tablePrice" [label]="'Equivalencias'" [labelPosition]="'bottom'"></agenx-table>
      <div class="agenx-create-edit__button--textarea">
        <agenx-textarea [control]="getControlOf('observations')" class="agenx-create-edit__inputs__textarea"
          [label]="'Observaciones'"></agenx-textarea>
      </div>
    }
     @if (!noWaste) {
      <div class="agenx-create-edit__button--textarea-buttons space-between">
        <h3 class="total-text">Total: ${{ total | number }}</h3>
        <div class="buttons-div">
          @if (showCancel) {
          <agenx-button class="agenx-create-edit__button" [typeButton]="'red'" [buttonText]="'Cancelar'"
            (click)="onCancel()"></agenx-button>
          }
          <agenx-button class="agenx-create-edit__button" [buttonText]="btn_add"
            (click)="onAddAforo()" ></agenx-button>
        </div>
      </div>
     }
    </div>
  </agenx-card>

  @if (!noWaste) {
    <agenx-card [title]="'LISTA ITEMS AFOROS'" [borderTopLess]="true">
      @if (gauges.length === 0) {
      <agenx-alert [alertType]="'error'" [alertText]="'No se han agregado aforos.'"></agenx-alert>
      }
      <div class="agenx-create-edit__cards">
        @for (card of gauges; track card.id) {
        <agenx-card-gauge [typeCard]="card.color ?? 'blue'" [modelCard]="'simple'" [index]="$index"
          (selectedCardSub)="onClickSubCard($event)" [buttonCardText]="''"
            [card_info]="card"></agenx-card-gauge>
        }
      </div>
      <div class="agenx-mt--4">
        @if (pages.length > 0) {
        <agenx-paginator (returnedPage)="setPaginator($event)" [currentPage]="pageSelected"
          [pages]="pages"></agenx-paginator>
        }
      </div>
    </agenx-card>
  }

  <agenx-card [title]="'DATOS ADICIONALES'" [borderTopLess]="noWaste">
    <div class="agenx-create-edit__inputs--three">
      <agenx-select [idInput]="'vehicle'" [control]="getCtrlPayForm('vehicle')" [options]="vehOptions"
        [label]="'Vehículo'" (onChange)="onVehicleSelect()"></agenx-select>
        @if (vehicleSel?.operators?.length! > 0) {
        <div class="border-blue">
          <div class="overflow-operators">
            @for (operator of vehicleSel?.operators!; track $index) {
              <div class="grid-operators">
                <div class="looper-width">
                  <div class="flex">
                    <img width="18px" height="18px" alt="." src="/assets/icons/com-icon-perfil-usuario.svg">
                    <p class="">{{operator.name}}</p>
                  </div>
                </div>
                <div style="flex-grow: 1;">
                  <div class="">
                    {{operator.type_name}}
                  </div>
                </div>
              </div>
            }
          </div>
          <label>Operarios</label>
        </div>
        } @else {
          <div style="padding-bottom: 0.5rem">
            <agenx-button [buttonText]="'Asignar operario'" (click)="openDialogOperators()"
                [sizeButton]="'full'" [disabled]="!vehicleSel"></agenx-button>
          </div>
        }

      @if (noWaste) {
        <agenx-select [idInput]="'reason'" [control]="getCtrlPayForm('reason')" [options]="reasonOptions"
          [label]="'Motivo'"></agenx-select>
      } @else {
        <agenx-select [idInput]="'type_billing'" [control]="getCtrlPayForm('type_billing')" [options]="typesBilOptions"
          [label]="'Tipo de facturación'" (onChange)="showPayMethods()"></agenx-select>
        @if (payOptions.length > 0) {
          <agenx-select [idInput]="'pay_method'" [control]="getCtrlPayForm('pay_method')" [options]="payOptions"
            [label]="'Medio de pago'" (onChange)="onPayMethodSel()"></agenx-select>
        }
        @if (needSubsService) {
          <agenx-input [control]="getCtrlPayForm('subscribed_service')" [type]="'text'" [placeholder]="''" [idInput]="'subscribed_service'"
            [label]="'Número servicio suscrito'"></agenx-input>
        }
        @if (needVoucher) {
          <agenx-input [control]="getCtrlPayForm('voucher')" [type]="'text'" [placeholder]="''" [idInput]="'voucher'"
            [label]="'Número comprobante'"></agenx-input>
        }
        @if (needInstallments) {
          <agenx-input [control]="getCtrlPayForm('installments')" [type]="'text'" [placeholder]="''" [idInput]="'installments'"
            [label]="'Número de cuotas'"></agenx-input>
        }
        <agenx-textarea [control]="getCtrlPayForm('observations_gen')" class="agenx-create-edit__inputs__textarea"
          [label]="'Observaciones generales'"></agenx-textarea>
      }
    </div>
  </agenx-card>

  <agenx-card [title]="'EVIDENCIAS'">
    <div class="agenx-create-edit__inputs--signature">

      @if (signatureImg) {
      <div class="agenx-create-edit__signature">
        <img class="agenx-create-edit__signature-img" [src]="signatureImg" alt="signature" srcset="" />
        <a class="agenx-create-edit__signature__edit-file" (click)="editSignature('aforo')">
          <img class="agenx-create-edit__signature__img" alt="edit icon"
            [src]="icon_edit_src" />
        </a>
        <a class="agenx-create-edit__signature__delete-file" (click)="deleteSignature('aforo')">
          <img class="agenx-create-edit__signature__img" alt="delete icon"
            [src]="icon_delete_src" />
        </a>
      </div>
      } @else {
      <div>
        <agenx-button [buttonText]="'Firma aforador'" (click)="openDialogSignature('aforo')"
          [sizeButton]="'full'"></agenx-button>
        @if (error_sign_flume) {
        <span class="error-btn">No se han agregado la firma del aforador.</span>
        }
      </div>
      }

      @if (signatureImgSub) {
      <div class="agenx-create-edit__signature">
        <img class="agenx-create-edit__signature-img" [src]="signatureImgSub" alt="signature" srcset="" />
        <a class="agenx-create-edit__signature__edit-file" (click)="editSignature('sub')">
          <img class="agenx-create-edit__signature__img" alt="edit icon"
            [src]="icon_edit_src" />
        </a>
        <a class="agenx-create-edit__signature__delete-file" (click)="deleteSignature('sub')">
          <img class="agenx-create-edit__signature__img" alt="delete icon"
            [src]="icon_delete_src" />
        </a>
      </div>
      } @else {
      <div>
        <agenx-button (click)="openDialogSignature('sub')" #buttonTest [buttonText]="'Firma ' + (data_form.niud != '---' ? 'suscriptor' : 'cliente')"
          [sizeButton]="'full'"></agenx-button>
        @if (error_sign_sub) {
        <span class="error-btn">No se han agregado la firma del suscriptor.</span>
        }
      </div>
      }
      <agenx-input-img (fileChange)="files = $event" [control]="photos" [type]="'number'" [placeholder]="''"
        [idInput]="'photos'" [label]="'Evidencias fotografícas'" [load_files]="load_evidences"
        (fileDelete)="deletePermanentFile($event)"></agenx-input-img>

    </div>
    @if (!data_form.email) {
    <agenx-input [control]="newEmail" [placeholder]="''" [labelPosition]="'bottom'"
      [idInput]="'Agregar Correo electrónico'" [label]="'Agregar correo electronico'"></agenx-input>
    <span class="error-btn" style="color: black;">Para agregar varios correos debe separarlos por punto y coma
      (;).</span>
    }
    @if (no_internet) {
      <div style="margin-top: 1rem;">
        <agenx-alert [alertType]="'warning'" [alertText]="'Actualmente no cuenta con una conexión estable a internet,' +
        ' se guardará el registro, pero este se creará automáticamente al contar con una buena conexión.'"></agenx-alert>
      </div>
    }
    <div class="agenx-mt--4" style="display: flex; gap: 0.6rem;">
      <agenx-button class="agenx-create-edit__button" (click)="save()" [buttonText]="'Guardar'"
        [loadingButton]="save_btn"></agenx-button>
      <agenx-button class="agenx-create-edit__button" [typeButton]="'red'" [buttonText]="'Volver'"
        (click)="router.navigateByUrl('/dashboard')"></agenx-button>
    </div>

  </agenx-card>
  } @else {
  <agenx-alert-radio [alertText]="'Consultando la información del aforo'" alertType="info"
    [loading]="true"></agenx-alert-radio>
  }
</main>
